import { useEffect, useState } from "react";
import { Form, Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SF_APP_DTL_INVC,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";
import { SF_APP_DTL_ADD_ITM, SF_APP_RGST_OFCR_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppAddItmService";
import { APP_DTL_ADD_ITM } from "./APP_DTL_ADD_ITM";
import { APP_AMD_DTL_ADD_ITM } from "./APP_AMD_DTL_ADD_ITM";
import { APP_AMD_RGST_OFCR_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_RGST_OFCR_ADD_ITM";

export const APP_AMD_DTL_INVC = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const form = {
        appDtlInvc: useForm({
            defaultSchema: SF_APP_DTL_INVC,
        }),

        appDtlAddItm: useForm({
            defaultSchema: SF_APP_DTL_ADD_ITM,
        }),
        appRgstOfcrAddItm: useForm({
            defaultSchema: SF_APP_RGST_OFCR_ADD_ITM,
        }),
    };

    const bfAppInfo = props.bfParam?.appId != null && props.bfParam?.appId !== ""
        ? props.bfParam
        : { ...props.form?.getValues() };
    const bfForm = {
        appDtlInvc: useForm({
            defaultSchema: SF_APP_DTL_INVC,
        }),

        appDtlAddItm: useForm({
            defaultSchema: SF_APP_DTL_ADD_ITM,
        }),
        appRgstOfcrAddItm: useForm({
            defaultSchema: SF_APP_RGST_OFCR_ADD_ITM,
        }),
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    /*
     * Application Invoice Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            fetch.getAppInvcInfo.fetch();
        },
    };

    const fetch = {
        // Get Application Invoice Information !== 신청서 송장 정보 조회 ==!.
        getAppInvcInfo: useFetch({
            api: () => COMN_APIS.getAppInvcInfo({ ...props.state }),
            onSuccess: (data) => {
                form.appDtlInvc.setValues(data.appInvcInfo?.content || []);
                // bfForm.appDtlInvc.setSchema("fobVal", { size: 10 });
                // bfForm.appDtlInvc.setSchema("frghVal", { size: 10 });
                // bfForm.appDtlInvc.setSchema("insrVal", { size: 10 });
                // bfForm.appDtlInvc.setSchema("othrCostVal", { size: 10 });

                // form.appDtlInvc.setSchema("invcCurrCd", { size: 2 });
                // form.appDtlInvc.setSchema("fobVal", { size: 10 });
                // form.appDtlInvc.setSchema("frghVal", { size: 10 });
                // form.appDtlInvc.setSchema("insrVal", { size: 10 });
                // form.appDtlInvc.setSchema("othrCostVal", { size: 10 });

                fetch.getBeforeAppInvcInfo.fetch();
            },
            onError: (error) => {},
            showToast: false,
        }),
        // Get Application Invoice Information(Before) !== 신청서 송장 정보 조회(수정전) ==!.
        getBeforeAppInvcInfo: useFetch({
            api: () => COMN_APIS.getAppInvcInfo({ ...bfAppInfo }),
            onSuccess: (data) => {
                bfForm.appDtlInvc.setValues(data.appInvcInfo?.content || []);

                if (
                    !comnUtils.isEmpty(form.appDtlInvc.getValues()) &&
                    !comnUtils.isEmpty(bfForm.appDtlInvc.getValues())
                ) {
                    Object.entries(form.appDtlInvc.getValues()).forEach((afItem) => {
                        Object.entries(bfForm.appDtlInvc.getValues()).forEach((bfItem) => {
                            if (afItem[0] == bfItem[0]) {
                                if (afItem[1] != bfItem[1]) {
                                    form.appDtlInvc.setSchema(afItem[0], {
                                        edit: true,
                                        borderColor: "warning",
                                        readOnly: true,
                                    });
                                }
                            }
                        });
                    });
                }
            },
            onError: (error) => {},
            showToast: false,
        }),
    };

    return (
        <>
            <Layout gap={2}>
                {/* Invoice Info Before Modification Start */}
                <Group>
                    <Group.Body>
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_INVC"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlInvc.schema.dlvrTermsNm} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlInvc.schema.invcCurrNm} />
                                    <Group.Control {...bfForm.appDtlInvc.schema.invcExrt} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_FOB" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...bfForm.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...bfForm.appDtlInvc.schema.fobVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...bfForm.appDtlInvc.schema.fobTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_FRGH" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...bfForm.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...bfForm.appDtlInvc.schema.frghVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...bfForm.appDtlInvc.schema.frghTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_INSR" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...bfForm.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...bfForm.appDtlInvc.schema.insrVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...bfForm.appDtlInvc.schema.insrTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_OTHR_COST" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...bfForm.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...bfForm.appDtlInvc.schema.othrCostVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...bfForm.appDtlInvc.schema.othrCostTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...bfForm.appDtlInvc.schema.cstmUsdVal} align="right" />
                                    <Group.Control {...bfForm.appDtlInvc.schema.cstmTzsVal} align="right" />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                        {/* ADD ITEM DETAIL */}
                        <APP_DTL_ADD_ITM param={bfAppInfo} form={bfForm} area={"INV"} />
                        <APP_AMD_RGST_OFCR_ADD_ITM displayMode="before" param={bfAppInfo} form={bfForm} area={"INV"} />
                    </Group.Body>
                </Group>
                {/* Invoice Info Before Modification End */}
                {/* Invoice Info After Modification Start */}
                <Group>
                    <Group.Body>
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"T_INVC"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.appDtlInvc.schema.dlvrTermsNm} controlSize={10} />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlInvc.schema.invcCurrNm} />
                                    <Group.Control {...form.appDtlInvc.schema.invcExrt} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_FOB" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...form.appDtlInvc.schema.fobVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...form.appDtlInvc.schema.fobTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_FRGH" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...form.appDtlInvc.schema.frghVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...form.appDtlInvc.schema.frghTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_INSR" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...form.appDtlInvc.schema.insrVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...form.appDtlInvc.schema.insrTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Label label="L_OTHR_COST" />
                                    <Group.Field>
                                        <Layout>
                                            <Layout.Left size={2}>
                                                <FormControl {...form.appDtlInvc.schema.invcCurrCd}></FormControl>
                                            </Layout.Left>
                                            <Layout.Right>
                                                <FormControl {...form.appDtlInvc.schema.othrCostVal}></FormControl>
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Field>

                                    <Group.Control {...form.appDtlInvc.schema.othrCostTzsVal} align="right" />
                                </Group.Row>

                                <Group.Row>
                                    <Group.Control {...form.appDtlInvc.schema.cstmUsdVal} align="right" />
                                    <Group.Control {...form.appDtlInvc.schema.cstmTzsVal} align="right" />
                                </Group.Row>
                            </Group.Section>
                        </Layout>
                        {/* ADD ITEM DETAIL */}
                        <APP_AMD_DTL_ADD_ITM bfParam={bfAppInfo} param={props.state} form={form} area={"INV"} />
                        <APP_AMD_RGST_OFCR_ADD_ITM bfParam={bfAppInfo} bfOfcrAddItmForm={bfForm.appRgstOfcrAddItm} param={props.state} form={form} area={"INV"} ofcrAddItmEditable={props.ofcrAddItmEditable} onOfcrAddItmChange={props.onOfcrAddItmChange} onRegisterTabSave={props.onRegisterTabSave} onRegisterTabValid={props.onRegisterTabValid} />
                    </Group.Body>
                </Group>
                {/* Invoice Info After Modification End */}
            </Layout>
        </>
    );
};
